/* eslint-disable no-unused-vars */
import loansImg from '../../../images/icons/loans.svg'
import feedbacksImg from '../../../images/icons/feedbacks.svg'
import distributorImg from '../../../images/icons/distributor.svg'
import rolesImg from '../../../images/icons/roles.svg'
import dashboardImg from '../../../images/icons/dashboard.svg'
import applicationsImg from '../../../images/icons/applications.svg'
import contactImg from '../../../images/icons/contact.svg'
import { checkIsAdmin } from '../../../redux/globalSelectors'
import transactionsImg from '../../../images/icons/interest.svg'
import TransactionImg from '../../../images/icons/transaction.svg'
import sysLogsImg from '../../../images/icons/system-logs.png'
import ClosedLoanImg from '../../../images/close loan.svg'
import HomeImage from '../../../images/icons/home.svg'
import NotificationImg from '../../../images/icons/bell.svg'
import approvedImg from '../../../images/icons/approved-icon.svg'
import AdministrationImg from '../../../images/icons/administrator_line_icon.svg'
import { BLACKLIST, MESSAGE } from '../../HomePage/constant'

const WELCOME = 'Welcome'
const HOME = 'Home'
const LOG_OUT = 'Log Out'
const FEEDBACKS = 'Feedbacks'
const RETURN_TO_WEBSITE = 'Return to Website'
const APPLICATION = 'Applications'
const LOANS = 'Loans'
const APPROVED = 'Approved'
const CLOSED_LOANS = 'Closed Loans'
const CUSTOMERS = 'Customers'
const ROLES = 'Roles'
const ADMINISTRATION = 'Administration'
const DASHBOARD = 'Dashboard'
const Transactions = 'Transactions'
const SYSTEM_LOGS = 'System Logs'
const FINANCE = 'Finance'
// const APPLY_FOR_LOAN = 'Apply for Loans'
const INTEREST_TRACKER = 'Interest Tracker'
const APPLICATIONS = 'Applications'
const TRANSACTIONS = 'Transactions'
const DIRECTORS = 'Directors'
const DISTRIBUTORS = 'Distributors'
const Leads = 'Leads'
// const UPLOAD_DOCS = 'Upload_Docs'
const CUSTOMER_DIRECTOR = 'Customer Directors'
const NOTIFICATION = 'Notifications'
const Read = 'Read'
const CUSTOMERSMODULE = 'Customer Module'
const MARK_AS_READ = 'Mark all as Read'
const RISK_MANAGEMENT = 'Risk Management'

// const DOCUMENTS = 'Documents'
const ADMIN_SIDE_MENU = [
  // {
  //   id: '0',
  //   title: 'Profile',
  //   icon: true,
  //   route: '/profile'
  // },
  {
    id: 'admin-nav-1',
    title: DASHBOARD,
    image: dashboardImg,
    route: `${checkIsAdmin() ? '/admin-dashboard' : '/dashboard'}`
  },
  {
    id: 2,
    route: '/admin-customers-module',
    title: CUSTOMERSMODULE,
    image: contactImg
  },
  {
    id: 3,
    route: '/admin-pending',
    title: APPLICATIONS,
    image: applicationsImg
  },
  {
    id: 'admin-nav-16',
    route: '/risk-management',
    title: RISK_MANAGEMENT,
    image: transactionsImg
  },
  {
    id: '4',
    title: LOANS,
    image: loansImg,
    route: '/admin-disbursed'
  },
  {
    id: '5',
    route: '/admin-approved',
    title: APPROVED,
    image: approvedImg
  },
  {
    id: '6',
    title: CLOSED_LOANS,
    image: ClosedLoanImg,
    route: '/closed-loans'
  },
  {
    id: '7',
    title: INTEREST_TRACKER,
    image: transactionsImg,
    route: '/interest-tracker'
  },
  {
    id: '8',
    title: FINANCE,
    image: transactionsImg,
    route: '/finance'
  },
  {
    id: '9',
    title: DISTRIBUTORS,
    image: distributorImg,
    route: '/distributors'
  },
  {
    id: '10',
    title: ROLES,
    image: rolesImg,
    route: '/admin-roles'
  },
  {
    id: '11',
    title: Leads,
    image: rolesImg,
    route: '/admin-leads'
  },
  {
    id: '12',
    title: ADMINISTRATION,
    image: AdministrationImg,
    route: '/administration'
  },
  {
    id: '13',
    title: SYSTEM_LOGS,
    image: sysLogsImg,
    route: '/system-logs'
  },
  {
    id: '14',
    title: FEEDBACKS,
    image: feedbacksImg,
    route: '/feedbacks'
  },
  {
    id: '15',
    title: MESSAGE,
    image: feedbacksImg,
    route: '/messages'
  },

  {
    id: '16',
    title: BLACKLIST,
    image: feedbacksImg,
    route: '/blacklist'
  }

  // {
  //   id: '8',
  //   title: Transactions,
  //   image: TransactionImg,
  //   route: '/transactions'
  // },

  // {
  //   id: '10',
  //   title: CUSTOMER_DIRECTOR,
  //   image: CustomerDirImg,
  //   route: '/customer-directors'
  // },

  // {
  //   id: '9',
  //   title: APPLY_FOR_LOAN,
  //   image: loansImg,
  //   route: '/apply-for-loan'
  // },
  // {
  //   id: '10',
  //   title: UPLOAD_DOCS,
  //   image: applicationsImg,
  //   route: '/admin-upload-docs'
  // },

  // {
  //   id: '12',
  //   title: TEMPLATES,
  //   image: templateImg,
  //   route: '/templates'
  // },
]
const NOTIFICATION_DATA = [
  {
    id: 0,
    title: 'Congratulation!!! your loan has been aprroved',
    content:
      'Lorem ipsum dolor sit amet consectetur adipiscing Lorem ipsum dolor sit amet consectetur...'
  },
  {
    id: 2,
    title: 'Loan Payment',
    content:
      'Lorem ipsum dolor sit amet consectetur adipiscing Lorem ipsum dolor sit amet consectetur...'
  },
  {
    id: 3,
    title: 'Interest Rate',
    content:
      'Lorem ipsum dolor sit amet consectetur adipiscing Lorem ipsum dolor sit amet consectetur...'
  },
  {
    id: 4,
    title: 'Next Loan Payment',
    content:
      'Lorem ipsum dolor sit amet consectetur adipiscing Lorem ipsum dolor sit amet consectetur...'
  }
]

export const SIDE_MENU = [
  { id: 1, path: '/dashboard', url: '/dashboard', title: HOME, image: HomeImage },
  {
    id: 2,
    url: '/applications/all-application',
    path: [
      '/applications/all-application',
      '/applications/application-in-review',
      '/applications/approved-application',
      '/applications/declined-application'
    ],
    title: APPLICATIONS,
    image: applicationsImg
  },
  { id: 3, path: '/directors', url: '/directors', title: DIRECTORS, image: contactImg },
  {
    id: 4,
    path: '/transactions',
    url: '/transactions',
    title: TRANSACTIONS,
    image: TransactionImg
  },
  // NOT FUNCTIONAL AT THE MOMENT
  {
    id: 5,
    path: '/customer-notifications',
    url: '/customer-notifications',
    title: NOTIFICATION,
    image: NotificationImg
  },
  { id: 6, path: '/feedbacks', url: '/feedbacks', title: FEEDBACKS, image: feedbacksImg }
]

export const ADMIN_NAVBAR = [
  {
    id: 'nav-1',
    path: '/dashboard',
    component: ''
  },
  {
    id: 'nav-2',
    path: '/applications',
    component: ''
  },
  {
    id: 'nav-3',
    path: '/loans',
    component: ''
  },
  {
    id: 'nav-4',
    path: '/transactions',
    component: ''
  },
  {
    id: 'nav-5',
    path: '/feedbacks',
    component: ''
  }
]

export const SUPER_ADMIN_NAVBAR = [
  {
    id: 'super-nav-1',
    path: '/dashboard',
    component: ''
  },
  {
    id: 'super-nav-2',
    path: '/profile',
    component: ''
  }
]

export {
  ADMIN_SIDE_MENU,
  WELCOME,
  ADMINISTRATION,
  ROLES,
  CUSTOMERS,
  LOG_OUT,
  FEEDBACKS,
  RETURN_TO_WEBSITE,
  LOANS,
  APPLICATION,
  DASHBOARD,
  Transactions,
  SYSTEM_LOGS,
  NOTIFICATION_DATA,
  Read,
  MARK_AS_READ
}
